module.exports = __webpack_public_path__ + "static/media/humming-bird.c8d11861.svg";